import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import { useTable } from 'react-table';
import { Wrapper } from './styles';
import { columns } from './table-config';
import { useStandardization } from '../../../../screens/StandardizationScreen/context';

const getPopupInfo = (project) => {
  const popupInfo = {};
  if (!project?.freezeData) return popupInfo;

  project?.freezeData.forEach((info) => {
    popupInfo[info.phase] = info;
  });
  return popupInfo;
};

const Table = ({ rowsData = [] }) => {
  const { standardizationProject } = useStandardization();
  const wrapperRef = useRef(null);
  const popupInfoObj = getPopupInfo(standardizationProject);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, footerGroups, visibleColumns } = useTable({
    columns: columns,
    data: rowsData,
    popupInfoObj,
  });

  const onResize = useCallback(() => {
    // scoring table criteria header
    const parentCriteriaTh = document.getElementById('criteria-header_2');
    // scoring table criteria header width
    const parentCriteriaThWidth = parentCriteriaTh?.getBoundingClientRect()?.width;
    const criteriaTds = document.getElementsByClassName('td-criteria');
    for (let i = 0; i < criteriaTds.length; i++) {
      criteriaTds[i].style.width = `${parentCriteriaThWidth}px`;
    }
  }, []);

  useEffect(() => {
    if (!wrapperRef.current) return;

    const observer = new ResizeObserver(onResize);
    observer.observe(wrapperRef.current);

    return () => observer.disconnect();
  }, [wrapperRef.current]);

  useLayoutEffect(() => {
    onResize();
  }, []);

  return (
    <Wrapper ref={wrapperRef}>
      <table
        {...getTableProps()}
        className='table-history'>
        <tbody
          {...getTableBodyProps()}
          className='tbody-history'>
          {rows.map((row) => {
            prepareRow(row);
            const rowProps = row.getRowProps();
            return (
              <tr
                className='tr-history'
                key={rowProps.key}
                {...rowProps}>
                {row.cells.map((cell) => {
                  const columnStyles = cell.column.getCustomStyles && cell.column.getCustomStyles();
                  return (
                    <td
                      className={`td-history ${cell.column.classes || ''}`}
                      {...cell.getCellProps({
                        style: {
                          minWidth: columnStyles?.minWidth,
                          width: columnStyles?.width,
                          maxWidth: columnStyles?.maxWidth,
                        },
                      })}>
                      {cell.render('Cell')}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </Wrapper>
  );
};

export default Table;
